export default __webpack_public_path__ + "static/media/features_parking_lots.9738b1cf.png";